import React, { useEffect } from "react";
import { Card, Col, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { loadingTypes } from "../../../Utils/constant";
import { fetchBorrowerTotalLoanDetails } from "../../../store/reducers/dashboardSlice/api";
import { SpinnerBlock } from "../../../Utils/CustomComponent";
import { formatNumbers } from "../../../Utils";
import imb_portfolio_balance from "../../../assets/images/upcoming-payments.png";
import { ComingSoonWrapper } from "./Payments";

function PaymentSummary({ loanIdArr }) {
  const data = useSelector(
    (state) => state.dashboard.borrowerTotalLoanValues.data
  );
  const status = useSelector(
    (state) => state.dashboard.borrowerTotalLoanValues.status
  );
  const dispatch = useDispatch();

  useEffect(() => {
    if (status === loadingTypes.idle && loanIdArr?.length) {
      const requestBody = {
        loanrecid_list: loanIdArr,
      };
      dispatch(
        fetchBorrowerTotalLoanDetails({
          requestBody,
        })
      );
    }
  }, [dispatch, status, loanIdArr?.length]);

  return (
    <>
      {/* <Card className="border border-primary h-100 p-4"> */}
      <Card className="border border-primary shadow-sm rounded-lg h-100 paymentSummary">
        <Card.Header className="fs-5 text-start bg-white">
          Payment Summary
        </Card.Header>
        <Card.Body>
          {status === loadingTypes.loading ? (
            <SpinnerBlock height="30vh" />
          ) : (
            // <div className="fw-bold small w-100 d-flex align-items-center">
            //   <p>
            //     {" "}
            //     <img
            //       style={{ width: "75px", paddingRight: "10px" }}
            //       src={imb_portfolio_balance}
            //       alt=""
            //     />{" "}
            //   </p>
            //   <div>
            //     <p className="fs-6">
            //       Total UPB:{" "}
            //       <span className="text-muted">
            //         {formatNumbers(data?.[0]?.Total_UPB)}
            //       </span>
            //     </p>
            //     <p className="fs-6">
            //       Total Payment YTD:{" "}
            //       <span className="text-muted">
            //         {formatNumbers(data?.[0]?.Total_Payment_YTD)}
            //       </span>
            //     </p>
            //     <p className="fs-6">
            //       YTD Late Fees:{" "}
            //       <span className="text-muted">
            //         {formatNumbers(data?.[0]?.Late_Charges)}
            //       </span>
            //     </p>
            //     <p className="fs-6">
            //       YTD NSF Fees:{" "}
            //       <span className="text-muted">
            //         {formatNumbers(data?.[0]?.YTD_NSF_Fees)}
            //       </span>
            //     </p>
            //   </div>
            // </div>
            <Row className="text-center">
              <Col xs={12} md={6} className="mb-3">
                <ComingSoonWrapper
                  label={"Total UPB"}
                  tooltip={"Unpaid Principal Balance across all active loans."}
                >
                  <div className="border rounded p-3 shadow-sm bg-light">
                    <h6 className="mb-1 text-muted">Total UPB:</h6>
                    <span className={`fw-bold text-primary`}>
                      {formatNumbers(data?.[0]?.Total_UPB)}
                    </span>
                  </div>
                </ComingSoonWrapper>
              </Col>
              <Col xs={12} md={6} className="mb-3">
                <ComingSoonWrapper
                  label={"Total Interest Paid YTD"}
                  tooltip={"Total interest you've paid this calendar year."}
                >
                  <div className="border rounded p-3 shadow-sm bg-light">
                    <h6 className="mb-1 text-muted">
                      Total Interest Paid YTD:
                    </h6>
                    <span className={`fw-bold text-primary`}>
                      {formatNumbers(data?.[0]?.Total_Payment_YTD)}
                    </span>
                  </div>
                </ComingSoonWrapper>
              </Col>
              <Col
                xs={12}
                md={6}
                className="mb-3"
                // title="Total late fees assessed Year-To-Date."
              >
                <ComingSoonWrapper
                  label={"YTD Late Fees"}
                  tooltip={"Total late fees assessed Year-To-Date."}
                >
                  <div className="border rounded p-3 shadow-sm bg-light">
                    <h6 className="mb-1 text-muted">YTD Late Fees:</h6>
                    <span className={`fw-bold text-primary`}>
                      {formatNumbers(data?.[0]?.Late_Charges)}
                    </span>
                  </div>
                </ComingSoonWrapper>
              </Col>
              <Col
                xs={12}
                md={6}
                className="mb-3"
                // title="Total Non-Sufficient Funds (NSF) fees charged Year-To-Date."
              >
                <ComingSoonWrapper
                  label={"YTD NSF Fees"}
                  tooltip={
                    "Total Non-Sufficient Funds (NSF) fees charged Year-To-Date."
                  }
                >
                  <div className="border rounded p-3 shadow-sm bg-light">
                    <h6 className="mb-1 text-muted">YTD NSF Fees:</h6>
                    <span className={`fw-bold text-primary`}>
                      {formatNumbers(data?.[0]?.YTD_NSF_Fees)}
                    </span>
                  </div>
                </ComingSoonWrapper>
              </Col>
            </Row>
          )}
        </Card.Body>
      </Card>
    </>
  );
}

export default PaymentSummary;
